import WorkbookTemplateCard from "./WorkbookTemplateCard";
export default WorkbookTemplateCard;
